// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3wGHf","text":"style_text__12i8q"};